import { toast } from 'react-toastify';
import ToastBody from 'app/components/ToastBody';

export const TOASTER_SUCCESS = 'success';
export const TOASTER_ERROR = 'error';
export const TOASTER_WARNING = 'warn';
export const TOASTER_INFO = 'info';

const TYPES = [TOASTER_SUCCESS, TOASTER_ERROR, TOASTER_WARNING, TOASTER_INFO];

// Pesan bawaan API yang masih berbahasa Inggris -> bahasa yang ramah.
const TRANSLATE = {
  'login successfully': 'Selamat datang kembali!',
  'logout successfully': 'Anda telah keluar.',
  'logging out': 'Anda telah keluar.',
  'file has been downloaded': 'File berhasil diunduh.',
  'download file success': 'File berhasil diunduh.',
  'token generated succesfuly': 'Sesi berhasil diperbarui.',
  'network error': 'Tidak dapat terhubung ke server. Periksa koneksi internet Anda.',
  'request error': 'Permintaan gagal diproses. Silakan coba lagi.',
  'unauthenticated.': 'Sesi Anda telah berakhir, silakan masuk kembali.'
};

// Notifikasi sukses yang hanya "data berhasil dibuka" tidak perlu ditampilkan.
const NOISE = [/^data berhasil diakses\.?$/i, /^data found\b/i];

/**
 * Rapikan teks pesan: buang kode status di depan ("200 - ", "422 ") yang
 * dulu ditempel di ratusan pemanggilan `${status} - ${message}`.
 */
const cleanMessage = (raw) => {
  let text = String(raw ?? '').trim();
  text = text.replace(/^\s*(undefined|null|\d{3})\s*[-–:]?\s*/i, '').trim();
  if (!text || /^(undefined|null)$/i.test(text)) return '';
  return TRANSLATE[text.toLowerCase()] ?? text;
};

// type = info, success, warn, error
// position = top-left, top-right, top-center, bottom-left, bottom-right, bottom-center
const toaster = (message = '', type = null, duration = 3500, position = 'top-right') => {
  // Beberapa pemanggilan lama memakai urutan terbalik: toaster(TOASTER_ERROR, 'pesan').
  if (TYPES.includes(message) && !TYPES.includes(type)) {
    [message, type] = [type, message];
  }
  if (!TYPES.includes(type)) return;

  let text = cleanMessage(message);
  if (type === TOASTER_SUCCESS && NOISE.some((re) => re.test(text))) return;
  if (!text) {
    if (type !== TOASTER_ERROR) return;
    text = 'Terjadi kesalahan. Silakan coba lagi.';
  }

  const show = {
    [TOASTER_SUCCESS]: toast.success,
    [TOASTER_ERROR]: toast.error,
    [TOASTER_WARNING]: toast.warn,
    [TOASTER_INFO]: toast.info
  }[type];

  show(<ToastBody type={type} message={text} />, {
    position,
    autoClose: type === TOASTER_ERROR ? Math.max(duration, 5000) : duration,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    icon: false,
    className: `mp-toast mp-toast--${type}`
  });
};
export default toaster;
